/** See `src/i18n/locales/en/reports.ts`. */
export const reports = {
  page: {
    title: 'Αναφορές',
    lead: 'Αναφορές για {{company}}, βασισμένες σε υπάρχοντα δεδομένα — δεν αποθηκεύονται ξεχωριστά δεδομένα αναφορών.',
    noScope: 'Επιλέξτε μια εταιρεία για να δείτε τις αναφορές της.',
    forbidden: 'Δεν επιτρέπεται να δείτε τις αναφορές αυτής της εταιρείας.',
  },
  library: {
    title: 'Βιβλιοθήκη αναφορών',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Μηνιαίες τάσεις ζωτικότητας',
      description: 'Συνολικά βήματα ανά μήνα σε όλη την εταιρεία.',
    },
    deelnamerapport: {
      title: 'Αναφορά συμμετοχής',
      description: 'Πόσα μέλη είναι ενεργά, και πόσο πρόσφατα.',
    },
    'challenge-resultaten': {
      title: 'Αποτελέσματα προκλήσεων',
      description: 'Προκλήσεις ανά κατάσταση και μέση πρόοδος συμμετεχόντων.',
    },
    communicatiebereik: {
      title: 'Εμβέλεια επικοινωνίας',
      description: 'Ειδοποιήσεις που στάλθηκαν, παραδόθηκαν και ανοίχτηκαν.',
    },
    documentgebruik: {
      title: 'Χρήση εγγράφων',
      description: 'Δημοσιευμένα/αρχειοθετημένα έγγραφα και ο συνολικός αριθμός προβολών τους.',
    },
  },
  actions: {
    exportCsv: 'Εξαγωγή CSV',
    exportPdf: 'Εξαγωγή PDF',
  },
  export: {
    pdfFallbackNote:
      'Η εξαγωγή PDF δεν είναι ακόμη διαθέσιμη — αντ’ αυτού έγινε λήψη ενός αρχείου CSV.',
    error: 'Δεν ήταν δυνατή η εξαγωγή αυτής της αναφοράς.',
  },
} as const;
